var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalTech5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "uhw0rvg9ta",
    width: "158.6%",
    height: "158.6%",
    x: "-29.3%",
    y: "-29.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "iju3xa9rdb",
    cx: 25.6,
    cy: 25.6,
    r: 25.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-771 -105) translate(781 115)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#uhw0rvg9ta)",
    xlinkHref: "#iju3xa9rdb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#iju3xa9rdb"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#041F41",
    d: "M23 29h5c3.866 0 7 3.134 7 7H16c0-3.866 3.134-7 7-7z",
    transform: "rotate(-180 25.5 32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    x: 7,
    y: 6,
    stroke: "#041F41",
    strokeWidth: 2,
    rx: 19
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#041F41",
    strokeLinecap: "square",
    d: "M15.449 21.601c1.333-2.402 2.667-3.603 4-3.603 1.333 0 2.667 1.2 4 3.603h0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#041F41",
    strokeLinecap: "square",
    d: "M28.449 21.601c1.333-2.402 2.667-3.603 4-3.603 1.333 0 2.667 1.2 4 3.603h0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalTech5);
export default __webpack_public_path__ + "static/media/globalTech5.e54f552448dbd21daf83ebe36981bd38.svg";
export { ForwardRef as ReactComponent };